import  React  from  'react';
import  {  Link  }  from  'react-router-dom';
import  {  useLanguage  }  from  '../context/LanguageContext';
import  {  Sun,  Mail,  Phone,  MapPin,  Linkedin,  Twitter,  Facebook  }  from  'lucide-react';

const  Footer  =  ()  =>  {
  const  {  t  }  =  useLanguage();

  return  (
  <footer  data-testid="footer"  className="bg-[#0B1120]  text-white">
  <div  className="container  mx-auto  px-4  py-16">
  <div  className="grid  grid-cols-1  md:grid-cols-2  lg:grid-cols-4  gap-12">
  {/*  Brand  */}
  <div>
  <div  className="flex  items-center  gap-2  mb-4">
  <div  className="w-10  h-10  bg-[#F97316]  rounded-full  flex  items-center  justify-center">
  <Sun  className="w-6  h-6  text-white"  />
  </div>
  <div>
  <span  className="text-xl  font-bold  font-['Manrope']  text-[#F97316]"  style={{  whiteSpace:  'nowrap'  }}>Thermasol&nbsp;Air&nbsp;Systems<sup>®</sup></span>
  </div>
  </div>
  <p  className="text-slate-400  mb-4">L'énergie  solaire  au  service  de  votre  performance</p>
  <p  className="text-sm  text-[#F97316]">Technologie PVT air hybride déposée INPI</p>
  <div  className="flex  gap-4  mt-6">
  <a  href="#"  className="w-10  h-10  bg-slate-800  rounded-full  flex  items-center  justify-center  hover:bg-[#F97316]  transition-colors"  aria-label="LinkedIn">
  <Linkedin  className="w-5  h-5"  />
  </a>
  <a  href="#"  className="w-10  h-10  bg-slate-800  rounded-full  flex  items-center  justify-center  hover:bg-[#F97316]  transition-colors"  aria-label="Twitter">
  <Twitter  className="w-5  h-5"  />
  </a>
  <a  href="#"  className="w-10  h-10  bg-slate-800  rounded-full  flex  items-center  justify-center  hover:bg-[#F97316]  transition-colors"  aria-label="Facebook">
  <Facebook  className="w-5  h-5"  />
  </a>
  </div>
  </div>

  {/*  Solutions  */}
  <div>
  <h4  className="font-bold  text-lg  mb-6">Solutions</h4>
  <ul  className="space-y-3">
  <li><Link  to="/sechoir-solaire"  className="text-slate-400  hover:text-[#F97316]  transition-colors">Séchage  Solaire</Link></li>
  <li><Link  to="/chauffage"  className="text-slate-400  hover:text-[#F97316]  transition-colors">Chauffage  des  Bâtiments</Link></li>
  <li><Link  to="/calculator"  className="text-slate-400  hover:text-[#F97316]  transition-colors">{t('nav.calculator')}</Link></li>
  </ul>
  </div>

  {/*  Company  */}
  <div>
  <h4  className="font-bold  text-lg  mb-6">{t('footer.company')}</h4>
  <ul  className="space-y-3">
  <li><Link  to="/"  className="text-slate-400  hover:text-[#F97316]  transition-colors">Notre  Technologie</Link></li>
  <li><Link  to="/find-installer"  className="text-slate-400  hover:text-[#F97316]  transition-colors">{t('nav.findInstaller')}</Link></li>
  <li><Link  to="/contact"  className="text-slate-400  hover:text-[#F97316]  transition-colors">{t('nav.contact')}</Link></li>
  </ul>
  </div>

  {/*  Contact  */}
  <div>
  <h4  className="font-bold  text-lg  mb-6">{t('nav.contact')}</h4>
  <ul  className="space-y-4">
  <li  className="flex  items-center  gap-3">
  <Phone  className="w-5  h-5  text-[#F97316]  flex-shrink-0"  />
  <a  href="tel:0184190449"  className="text-slate-400  hover:text-white  transition-colors  font-semibold">01  84  19  04  49</a>
  </li>
  <li  className="flex  items-center  gap-3">
  <Phone  className="w-5  h-5  text-[#F97316]  flex-shrink-0"  />
  <a  href="tel:0184190449"  className="text-slate-400  hover:text-white  transition-colors">01  84  19  04  49</a>
  </li>
  <li  className="flex  items-center  gap-3">
  <Mail  className="w-5  h-5  text-[#F97316]  flex-shrink-0"  />
  <a  href="mailto:contact@thermasol-airsystems.fr"  className="text-slate-400  hover:text-white  transition-colors"  style={{  whiteSpace:  'nowrap'  }}>contact@thermasol-airsystems.fr</a>
  </li>
  <li  className="flex  items-center  gap-3">
  <MapPin  className="w-5  h-5  text-[#F97316]  flex-shrink-0"  />
  <a  href="https://www.thermasol-airsystems.fr"  target="_blank"  rel="noopener  noreferrer"  className="text-slate-400  hover:text-white  transition-colors">www.thermasol-airsystems.fr</a>
  </li>
  </ul>
  </div>
  </div>

  {/*  Company  Legal  Info  */}
  <div  className="border-t  border-slate-800  mt-12  pt-8">
  <div  className="bg-slate-800/50  rounded-xl  p-6  max-w-2xl">
  <h4  className="font-bold  text-[#F97316]  mb-4">France  Energie</h4>
  <div  className="grid  md:grid-cols-2  gap-4  text-sm  text-slate-400">
  <div>
  <p  className="flex  items-start  gap-2">
  <MapPin  className="w-4  h-4  text-[#F97316]  flex-shrink-0  mt-0.5"  />
  <span>
  13  rue  des  Vignes<br  />
  91330  Yerres,  France
  </span>
  </p>
  </div>
  <div  className="space-y-2">
  <p><span  className="text-slate-300  font-semibold">SIRET  (siège):</span>  899  346  217  00024</p>
  <p  className="flex  items-center  gap-2">
  <Phone  className="w-4  h-4  text-[#F97316]  flex-shrink-0"  />
  <a  href="tel:0184190449"  className="hover:text-white  transition-colors">01  84  19  04  49</a>
  </p>
  </div>
  </div>
  </div>
  </div>

  {/*  Bottom  */}
  <div  className="border-t  border-slate-800  mt-8  pt-8  flex  flex-col  md:flex-row  justify-between  items-center  gap-4">
  <p  className="text-slate-500  text-sm">©  2026  <span  className="text-[#F97316]"  style={{  whiteSpace:  'nowrap'  }}>Thermasol&nbsp;Air&nbsp;Systems®</span>.  Tous  droits  réservés.</p>
  <div  className="flex  gap-6  text-sm">
  <a  href="/mentions-legales"  data-testid="footer-legal-link"  className="text-slate-500  hover:text-white  transition-colors">{t('footer.legal')}</a>
  <a  href="/politique-confidentialite"  data-testid="footer-privacy-link"  className="text-slate-500  hover:text-white  transition-colors">{t('footer.privacy')}</a>
  <Link  to="/documentation-sechoir"  data-testid="footer-espace-pro-link"  className="text-slate-500  hover:text-white  transition-colors">Espace  pro</Link>
  <button
  type="button"
  data-testid="footer-cookies-btn"
  onClick={()  =>  window.dispatchEvent(new  Event('open-cookie-banner'))}
  className="text-slate-500  hover:text-white  transition-colors  bg-transparent  border-0  cursor-pointer  p-0"
  >
  Cookies
  </button>
  </div>
  </div>
  </div>
  </footer>
  );
};

export  default  Footer;
